module.exports = __webpack_public_path__ + "media/4x3/ky-5814c5a9.svg";